module.exports = __webpack_public_path__ + "play_white.1541ca22.png";